// JavaScript to handle dot navigation
document.addEventListener("DOMContentLoaded", function() {
  // Select both the rows with individual product images and the product gallery section
  const productRows = document.querySelectorAll('.product-image, .gallery-image-row');
  const dotNavigation = document.createElement('div');
  dotNavigation.classList.add('dot-navigation');

  // Loop through each product image row and gallery, creating a dot for each
  productRows.forEach((row, index) => {
    const dot = document.createElement('div');
    dot.classList.add('dot');
    dot.dataset.index = index;

    // Handle click event to scroll smoothly to the corresponding row
    dot.addEventListener('click', () => {
      window.scrollTo({
        top: row.offsetTop,
        behavior: 'smooth'
      });
    });

    dotNavigation.appendChild(dot);
  });

  // Append the dot navigation to the body
  document.body.appendChild(dotNavigation);

  // Function to activate the dot based on scroll position
  function activateDot() {
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    productRows.forEach((row, index) => {
      const dot = document.querySelector(`.dot[data-index="${index}"]`);
      if (scrollPosition >= row.offsetTop && scrollPosition < row.offsetTop + row.offsetHeight) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  // Listen to the scroll event
  window.addEventListener('scroll', activateDot);
  activateDot(); // Activate the correct dot on page load
});

